export const MachidukuriThoughts = [
  {
    _id: '65c9872ff46bbd64cb2cd400',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z',
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1,
    },
    coverImage: {
      pcCoverImage: {
        _id: '6368b1040fc2fdb8ea8216aa',
        altText: '',
        description: '',
        fileName: 'profileImg.png',
        fileSize: 413079,
        fileType: 'image/png',
        height: 450,
        width: 634,
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/6f1d61f9-7e68-48a9-8ce2-1ca67258513a/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_1_1040x360.png',
        title: '',
      },
      spCoverImage: {
        _id: '6369b1040fc2fdb8ea8216aa',
        altText: '',
        description: '',
        fileName: 'profileImg.png',
        fileSize: 413079,
        fileType: 'image/png',
        height: 450,
        width: 634,
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/6f1d61f9-7e68-48a9-8ce2-1ca67258513a/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_1_1040x360.png',
        title: '',
      },
    },
    title:
      '①IT小売企業のトライアルグループと、日本有数（現段階45社、目標100社以上）の企業群が、DXの力で福岡をシリコンバレーのようなイノベーション地域に変える。すべての生活（食と健康）をよくして日本を元気にする！',
    tag: [
      {
        _id: '3bb39c1e-5423-4ca8-b7e0-9d688cb90928',
        tagColor: '#d38e69',
        name: '経営',
        _sys: {
          raw: {
            createdAt: '2024-02-12T06:55:58.840Z',
            updatedAt: '2024-02-12T06:55:58.840Z',
            firstPublishedAt: '2024-02-12T06:55:58.840Z',
            publishedAt: '2024-02-12T06:55:58.840Z',
          },
          createdAt: '2024-02-12T06:55:58.840Z',
          updatedAt: '2024-02-12T06:55:58.840Z',
          customOrder: 1,
        },
      },
    ],
    body: '',
    interviewee: {
      _id: '87c4f45e-f7a3-42ff-8d5e-f55251d325c7',
      fullName: '亀田晃一',
      profileImage: {
        _id: '0d13630a-42c4-4e79-9187-b60192067184',
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/9b71f3a4-5bfc-4199-9a16-5bf1213d610f/%E4%BA%80%E7%94%B0%E6%99%83%E4%B8%80.png',
        fileType: 'image/png',
        fileName: '',
        fileSize: 1028,
        width: 44,
        height: 44,
      },
      biography: '代表取締役社長',
      _sys: {
        raw: {
          createdAt: '2024-02-12T06:55:58.840Z',
          updatedAt: '2024-02-12T06:55:58.840Z',
          firstPublishedAt: '2024-02-12T06:55:58.840Z',
          publishedAt: '2024-02-12T06:55:58.840Z',
        },
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        customOrder: 1,
      },
    },
    publishDate: '2024-02-12',
  },
  {
    _id: '65c987f2f46bbd64cb2e0f23',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z',
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1,
    },
    coverImage: {
      pcCoverImage: {
        _id: '6368b1040fc2fdb8ea8216aa',
        altText: '',
        description: '',
        fileName: 'profileImg.png',
        fileSize: 413079,
        fileType: 'image/png',
        height: 450,
        width: 634,
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/af5dba61-0e67-4a4e-8418-62d61952358c/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_2_1040x360.png',
        title: '',
      },
      spCoverImage: {
        _id: '6369b1040fc2fdb8ea8216aa',
        altText: '',
        description: '',
        fileName: 'profileImg.png',
        fileSize: 413079,
        fileType: 'image/png',
        height: 450,
        width: 634,
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/af5dba61-0e67-4a4e-8418-62d61952358c/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_2_1040x360.png',
        title: '',
      },
    },
    title:
      '②IT小売企業のトライアルグループと、日本有数（現段階45社、目標100社以上）の企業群が、DXの力で福岡をシリコンバレーのようなイノベーション地域に変える。すべての生活（食と健康）をよくして日本を元気にする！',
    tag: [
      {
        _id: '3bb39c1e-5423-4ca8-b7e0-9d688cb90928',
        tagColor: '#d38e69',
        name: '経営',
        _sys: {
          raw: {
            createdAt: '2024-02-12T06:55:58.840Z',
            updatedAt: '2024-02-12T06:55:58.840Z',
            firstPublishedAt: '2024-02-12T06:55:58.840Z',
            publishedAt: '2024-02-12T06:55:58.840Z',
          },
          createdAt: '2024-02-12T06:55:58.840Z',
          updatedAt: '2024-02-12T06:55:58.840Z',
          customOrder: 1,
        },
      },
    ],
    body: '',
    interviewee: {
      _id: '87c4f45e-f7a3-42ff-8d5e-f55251d325c7',
      fullName: '亀田晃一',
      profileImage: {
        _id: '0d13630a-42c4-4e79-9187-b60192067184',
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/9b71f3a4-5bfc-4199-9a16-5bf1213d610f/%E4%BA%80%E7%94%B0%E6%99%83%E4%B8%80.png',
        fileType: 'image/png',
        fileName: '',
        fileSize: 1028,
        width: 44,
        height: 44,
      },
      biography: '代表取締役社長',
      _sys: {
        raw: {
          createdAt: '2024-02-12T06:55:58.840Z',
          updatedAt: '2024-02-12T06:55:58.840Z',
          firstPublishedAt: '2024-02-12T06:55:58.840Z',
          publishedAt: '2024-02-12T06:55:58.840Z',
        },
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        customOrder: 1,
      },
    },
    publishDate: '2024-02-12',
  },
  {
    _id: '65c98890f46bbd64cb2e6c39',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z',
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1,
    },
    coverImage: {
      pcCoverImage: {
        _id: '6368b1040fc2fdb8ea8216aa',
        altText: '',
        description: '',
        fileName: 'profileImg.png',
        fileSize: 413079,
        fileType: 'image/png',
        height: 450,
        width: 634,
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/5fb7c198-e2f8-445f-af22-e03abf051ff4/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_3_1040x360.png',
        title: '',
      },
      spCoverImage: {
        _id: '6369b1040fc2fdb8ea8216aa',
        altText: '',
        description: '',
        fileName: 'profileImg.png',
        fileSize: 413079,
        fileType: 'image/png',
        height: 450,
        width: 634,
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/5fb7c198-e2f8-445f-af22-e03abf051ff4/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_3_1040x360.png',
        title: '',
      },
    },
    title:
      '③IT小売企業のトライアルグループと、日本有数（現段階45社、目標100社以上）の企業群が、DXの力で福岡をシリコンバレーのようなイノベーション地域に変える。すべての生活（食と健康）をよくして日本を元気にする！',
    tag: [
      {
        _id: '3bb39c1e-5423-4ca8-b7e0-9d688cb90928',
        tagColor: '#d38e69',
        name: '経営',
        _sys: {
          raw: {
            createdAt: '2024-02-12T06:55:58.840Z',
            updatedAt: '2024-02-12T06:55:58.840Z',
            firstPublishedAt: '2024-02-12T06:55:58.840Z',
            publishedAt: '2024-02-12T06:55:58.840Z',
          },
          createdAt: '2024-02-12T06:55:58.840Z',
          updatedAt: '2024-02-12T06:55:58.840Z',
          customOrder: 1,
        },
      },
    ],
    body: '',
    interviewee: {
      _id: '87c4f45e-f7a3-42ff-8d5e-f55251d325c7',
      fullName: '亀田晃一',
      profileImage: {
        _id: '0d13630a-42c4-4e79-9187-b60192067184',
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/9b71f3a4-5bfc-4199-9a16-5bf1213d610f/%E4%BA%80%E7%94%B0%E6%99%83%E4%B8%80.png',
        fileType: 'image/png',
        fileName: '',
        fileSize: 1028,
        width: 44,
        height: 44,
      },
      biography: '代表取締役社長',
      _sys: {
        raw: {
          createdAt: '2024-02-12T06:55:58.840Z',
          updatedAt: '2024-02-12T06:55:58.840Z',
          firstPublishedAt: '2024-02-12T06:55:58.840Z',
          publishedAt: '2024-02-12T06:55:58.840Z',
        },
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        customOrder: 1,
      },
    },
    publishDate: '2024-02-12',
  },
  {
    _id: '65c988e7f46bbd64cb2e8933',
    _sys: {
      raw: {
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        firstPublishedAt: '2024-02-12T06:55:58.840Z',
        publishedAt: '2024-02-12T06:55:58.840Z',
      },
      createdAt: '2024-02-12T06:55:58.840Z',
      updatedAt: '2024-02-12T06:55:58.840Z',
      customOrder: 1,
    },
    coverImage: {
      pcCoverImage: {
        _id: '6368b1040fc2fdb8ea8216aa',
        altText: '',
        description: '',
        fileName: 'profileImg.png',
        fileSize: 413079,
        fileType: 'image/png',
        height: 450,
        width: 634,
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/e3b4d883-f5c6-4e67-b17f-59b933696e3f/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_4_1040x360.png',
        title: '',
      },
      spCoverImage: {
        _id: '6369b1040fc2fdb8ea8216aa',
        altText: '',
        description: '',
        fileName: 'profileImg.png',
        fileSize: 413079,
        fileType: 'image/png',
        height: 450,
        width: 634,
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/e3b4d883-f5c6-4e67-b17f-59b933696e3f/%E4%BA%80%E7%94%B0%E3%81%95%E3%82%93_%E5%85%B1%E9%80%9A%E3%83%8F%E3%82%99%E3%83%8A%E3%83%BC_4_1040x360.png',
        title: '',
      },
    },
    title:
      '④IT小売企業のトライアルグループと、日本有数（現段階45社、目標100社以上）の企業群が、DXの力で福岡をシリコンバレーのようなイノベーション地域に変える。すべての生活（食と健康）をよくして日本を元気にする！',
    tag: [
      {
        _id: '3bb39c1e-5423-4ca8-b7e0-9d688cb90928',
        tagColor: '#d38e69',
        name: '経営',
        _sys: {
          raw: {
            createdAt: '2024-02-12T06:55:58.840Z',
            updatedAt: '2024-02-12T06:55:58.840Z',
            firstPublishedAt: '2024-02-12T06:55:58.840Z',
            publishedAt: '2024-02-12T06:55:58.840Z',
          },
          createdAt: '2024-02-12T06:55:58.840Z',
          updatedAt: '2024-02-12T06:55:58.840Z',
          customOrder: 1,
        },
      },
    ],
    body: '',
    interviewee: {
      _id: '87c4f45e-f7a3-42ff-8d5e-f55251d325c7',
      fullName: '亀田晃一',
      profileImage: {
        _id: '0d13630a-42c4-4e79-9187-b60192067184',
        src: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/9b71f3a4-5bfc-4199-9a16-5bf1213d610f/%E4%BA%80%E7%94%B0%E6%99%83%E4%B8%80.png',
        fileType: 'image/png',
        fileName: '',
        fileSize: 1028,
        width: 44,
        height: 44,
      },
      biography: '代表取締役社長',
      _sys: {
        raw: {
          createdAt: '2024-02-12T06:55:58.840Z',
          updatedAt: '2024-02-12T06:55:58.840Z',
          firstPublishedAt: '2024-02-12T06:55:58.840Z',
          publishedAt: '2024-02-12T06:55:58.840Z',
        },
        createdAt: '2024-02-12T06:55:58.840Z',
        updatedAt: '2024-02-12T06:55:58.840Z',
        customOrder: 1,
      },
    },
    publishDate: '2024-02-12',
  },
]
